
                import "css-modules://src_components_typography"
                export default {"Text":"_d9fcc3","Title":"_062194","Subtitle":"_f9b51d"}
            